var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.isHomePage)?_c('NavBar'):_vm._e(),_c('v-main',{attrs:{"id":"home"}},[_c('div',{staticClass:"main-container"},[_c('router-view')],1)]),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }